export const griData: any = {
  "GRI 2: General Disclosures 2021": {
    "2-1 Organizational details": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a. report its legal name": ["text", ""],
      "b. report its nature of ownership and legal form": ["text", ""],
      "c. report the location of its headquarters": ["text", ""],
      "d. report its countries of operation": ["text", ""],
    },
    "2-2 Entities included in the organization's sustainability reporting": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.  list all its entities included in its sustainability reporting": [
        "table",
        [
          {
            "Name of Entity": "",
            "Nature of Business": "",
            Address: "",
            Remarks: "",
          },
        ],
      ],
      "b. if the organization has audited consolidated financial statements or financial information filed on public record, specify the differences between the list of entities included in its financial reporting and the list included in its sustainability reporting":
        ["text", ""],
      "c. If the organization consists of multiple entities, explain the approach used for  consolidating the information, including:":
        {
          "i. whether the approach involves adjustments to information for minority interests:":
            ["text", ""],
          "ii. how the approach takes into account mergers, acquisitions, and disposal of entities or parts of entities":
            ["text", ""],
          "iii. whether and how the approach differs across the disclosures in this Standard and across material topics.":
            ["text", ""],
        },
    },
    "2-3 Reporting period, frequency and contact point": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a. specify the reporting period for, and the frequency of, its sustainability reporting":
        ["text", ""],
      "b. specify the reporting period for its financial reporting and, if it does not align with the period for its sustainability reporting, explain the reason for this;":
        ["text", ""],
      "c. report the publication date of the report or reported information": [
        "text",
        "",
      ],
      "d. specify the contact point for questions about the report or reported information":
        ["text", ""],
    },
    "2-4 Restatements of information": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	report restatements of information made from previous reporting periods and explain":
        {
          "i. the reasons for the restatements": ["text", ""],
          "ii. the effect of the restatements": ["text", ""],
        },
    },
    "2-5 External assurance": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	describe its policy and practice for seeking external assurance, including whether and how the highest governance body and senior executives are involved":
        ["text", ""],
      "b.	if the organization's sustainability reporting has been externally assured:":
        {
          "i.	provide a link or reference to the external assurance report(s) or assurance statement(s)":
            ["text", ""],
          "ii. describe what has been assured and on what basis, including the assurance standards used, the level of assurance obtained, and any limitations of the assurance process":
            ["text", ""],
          "iii.	describe the relationship between the organization and the assurance provider.":
            ["text", ""],
        },
    },
    "2-6 Activities, value chain and other business relationships": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	report the sector(s) in which it is active": ["text", ""],
      "b.	describe its value chain, including:": {
        "i.	the organization’s activities, products, services, and markets served;":
          ["text", ""],
        "ii.	the organization’s supply chain;": ["text", ""],
        "iii.	the entities downstream from the organization and their activities;":
          ["text", ""],
      },
      "c.	report other relevant business relationships;": ["text", ""],
      "d.	describe significant changes in 2-6-a, 2-6-b, and 2-6-c compared to the previous reporting period.":
        ["text", ""],
    },
    "2-7 Employees": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	report the total number of employees, and a breakdown of this total by gender and by region;":
        ["text", ""],
      "b.	report the total number of:": [
        "table",
        [
          {
            "Employement type": "",
            Region: "",
            Male: "",
            Female: "",
          },
        ],
      ],
      "c.	describe the methodologies and assumptions used to compile the data, including whether the numbers are reported:":
        {
          "i.	in head count, full-time equivalent (FTE), or using another methodology;":
            ["text", ""],
          "ii. at the end of the reporting period, as an average across the reporting period, or using another methodology;":
            ["text", ""],
        },
      "d.	report contextual information necessary to understand the data reported under 2-7-a and 2-7-b;":
        ["text", ""],
      "e.	describe significant fluctuations in the number of employees during the reporting period and between reporting periods.":
        ["text", ""],
    },
    "2-8 Workers who are not employees": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	report the total number of workers who are not employees and whose work is controlled by the organization and describe:":
        {
          "i.	the most common types of worker and their contractual relationship with the organization;":
            ["text", ""],
          "ii.	the type of work they perform;": ["text", ""],
        },

      "b.	describe the methodologies and assumptions used to compile the data, including whether the number of workers who are not employees is reported:":
        {
          "i.	in head count, full-time equivalent (FTE), or using another methodology;":
            ["text", ""],
          "ii.	at the end of the reporting period, as an average across the reporting period, or using another methodology;":
            ["text", ""],
        },

      "c.	describe significant fluctuations in the number of workers who are not employees during the reporting period and between reporting periods.":
        ["text", ""],
    },
    "2-9 Governance structure and composition": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	describe its governance structure, including committees of the highest governance body;":
        ["text", ""],
      "b.	list the committees of the highest governance body that are responsible for decision- making on and overseeing the management of the organization's impacts on the economy, environment, and people;":
        ["text", ""],
      "c.	describe the composition of the highest governance body and its committees by:":
        [
          "table",
          [
            {
              Members: "",
              Independence: "",
              Tenure: "",
              "Other positions": "",
              Gender: "",
              "Under represented": "",
              Competencies: "",
              Stakeholder: "",
            },
          ],
        ],
    },
    "2-10 Nomination and selection of the highest governance body": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	describe the nomination and selection processes for the highest governance body and its committees;":
        ["text", ""],
      "b.	describe the criteria used for nominating and selecting highest governance body members, including whether and how the following are taken into consideration:":
        [
          "table",
          [
            {
              Stakeholder: "",
              Diversity: "",
              Independence: "",
              Competencies: "",
            },
          ],
        ],
    },
    "2-11 Chair of the highest governance body": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	report whether the chair of the highest governance body is also a senior executive in the organization;":
        ["text", ""],
      "b.	if the chair is also a senior executive, explain their function within the organization's management, the reasons for this arrangement, and how conflicts of interest are prevented and mitigated.":
        ["text", ""],
    },
    "2-12 Role of the highest governance body in overseeing the management of impacts":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a. describe the role of the highest governance body and of senior executives in developing, approving, and updating the organization's purpose, value or mission statements, strategies, policies, and goals related to sustainable development:":
          ["text", ""],
        "b. describe the role of the highest governance body in overseeing the organization's due diligence and other processes to identify and manage the organization's impacts on the economy, environment, and people, including:":
          {
            "i. whether and how the highest governance body engages with stakeholders to support these processes;":
              ["text", ""],
            "ii. how the highest governance body considers the outcomes of these processes;":
              ["text", ""],
          },
        "c. describe the role of the highest governance body in reviewing the effectiveness of the organization's processes as described in 2-12-b, and report the frequency of this review.":
          ["text", ""],
      },
    "2-13 Delegation of responsibility for managing impacts": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	describe how the highest governance body delegates responsibility for managing the organization's impacts on the economy, environment, and people, including:":
        {
          "i.	whether it has appointed any senior executives with responsibility for the management of impacts":
            ["text", ""],
          "ii.	whether it has delegated responsibility for the management of impacts to other employees":
            ["text", ""],
        },

      "b.	describe the process and frequency for senior executives or other employees to report back to the highest governance body on the management of the organization's impacts on the economy, environment, and people.":
        ["text", ""],
    },
    "2-14 Role of the highest governance body in sustainability reporting": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	report whether the highest governance body is responsible for reviewing and approving the reported information, including the organization's material topics, and if so, describe the process for reviewing and approving the information;":
        ["text", ""],
      "b.if the highest governance body is not responsible for reviewing and approving the reported information, including the organization's material topics, explain the reason for this.":
        ["text", ""],
    },
    "2-15 Conflicts of interest": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	describe the processes for the highest governance body to ensure that conflicts of interest are prevented and mitigated":
        ["text", ""],
      "b.	report whether conflicts of interest are disclosed to stakeholders, including, at a minimum, conflicts of interest relating to:":
        {
          "i.	cross-board membership;": ["text", ""],
          "ii. cross-shareholding with suppliers and other stakeholders;": [
            "text",
            "",
          ],
          "iii.	existence of controlling shareholders;": ["text", ""],
          "iv. related parties, their relationships, transactions, and outstanding balances.":
            ["text", ""],
        },
    },
    "2-16 Communication of critical concerns": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	describe whether and how critical concerns are communicated to the highest governance body;":
        ["text", ""],
      "b.	report the total number and the nature of critical concerns that were communicated to the highest governance body during the reporting period.":
        ["text", ""],
    },
    "2-17 Collective knowledge of the highest governance body": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	report measures taken to advance the collective knowledge, skills, and experience of the highest governance body on sustainable development.":
        ["text", ""],
    },
    "2-18 Evaluation of the performance of the highest governance body": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	describe the processes for evaluating the performance of the highest governance body in overseeing the management of the organization's impacts on the economy, environment, and people;":
        ["text", ""],
      "b.	report whether the evaluations are independent or not, and the frequency of the evaluations;":
        ["text", ""],
      "c.	describe actions taken in response to the evaluations, including changes to the composition of the highest governance body and organizational practices.":
        ["text", ""],
    },
    "2-19 Remuneration policies": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	describe the remuneration policies for members of the highest governance body and senior executives, including:":
        {
          "i.	fixed pay and variable pay;": ["text", ""],
          "ii.	sign-on bonuses or recruitment incentive payments;": ["text", ""],
          "iii.	termination payments;": ["text", ""],
          "iv.	clawbacks;": ["text", ""],
          "v.	retirement benefits;": ["text", ""],
        },
      "b.	describe how the remuneration policies for members of the highest governance body and senior executives relate to their objectives and performance in relation to the management of the organization's impacts on the economy, environment, and people.":
        ["text", ""],
    },
    "2-20 Process to determine remuneration": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	describe the process for designing its remuneration policies and for determining remuneration, including:":
        {
          "i.	whether independent highest governance body members or an independent remuneration committee oversees the process for determining remuneration;":
            ["text", ""],
          "ii.	how the views of stakeholders (including shareholders) regarding remuneration are sought and taken into consideration;":
            ["text", ""],
          "iii.	whether remuneration consultants are involved in determining remuneration and, if so, whether they are independent of the organization, its highest governance body and senior executives;":
            ["text", ""],
        },
      "b.	report the results of votes of stakeholders (including shareholders) on remuneration policies and proposals, if applicable":
        ["text", ""],
    },
    "2-21 Annual total compensation ratio": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	report the ratio of the annual total compensation for the organization's highest-paid individual to the median annual total compensation for all employees(excluding the highest-paid individual);":
        ["text", ""],
      "b.	report the ratio of the percentage increase in annual total compensation for the organization's highest-paid individual to the median percentage increase in annual total compensation for all employees (excluding the highest-paid individual);":
        ["text", ""],
      "c.	report contextual information necessary to understand the data and how the data has been compiled.":
        ["text", ""],
    },
    "2-22 Statement on sustainable development strategy": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	report a statement from the highest governance body or most senior executive of the organization about the relevance of sustainable development to the organization and its strategy for contributing to sustainable development.":
        ["text", ""],
    },
    "2-23 Policy commitments": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	describe its policy commitments for responsible business conduct, including:":
        {
          "i. the authoritative intergovernmental instruments that the commitments reference;":
            ["text", ""],
          "ii. whether the commitments stipulate conducting due diligence;": [
            "text",
            "",
          ],
          "iii.	whether the commitments stipulate applying the precautionary principle;":
            ["text", ""],
          "iv. whether the commitments stipulate respecting human rights;": [
            "text",
            "",
          ],
        },
      "b.	describe its specific policy commitment to respect human rights, including:":
        {
          "i.	the internationally recognized human rights that the commitment covers;":
            ["text", ""],
          "ii.	the categories of stakeholders, including at-risk or vulnerable groups, that the organization gives particular attention to in the commitment;":
            ["text", ""],
        },
      "c.	provide links to the policy commitments if publicly available, or, if the policy commitments are not publicly available, explain the reason for this;":
        ["text", ""],
      "d.	report the level at which each of the policy commitments was approved within the organization, including whether this is the most senior level;":
        ["text", ""],
      "e.	report the extent to which the policy commitments apply to the organization's activities and to its business relationships;":
        ["text", ""],
      "f.	describe how the policy commitments are communicated to workers, business partners, and other relevant parties.":
        ["text", ""],
    },
    "2-24 Embedding policy commitments": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	describe how it embeds each of its policy commitments for responsible business conduct throughout its activities and business relationships, including:":
        {
          "i.	how it allocates responsibility to implement the commitments across different levels within the organization;":
            ["text", ""],
          "ii.	how it integrates the commitments into organizational strategies, operational policies, and operational procedures;":
            ["text", ""],
          "iii.	how it implements its commitments with and through its business relationships;":
            ["text", ""],
          "iv.	training that the organization provides on implementing the commitments.":
            ["text", ""],
        },
    },
    "2-25 Processes to remediate negative impacts": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	describe its commitments to provide for or cooperate in the remediation of negative impacts that the organization identifies it has caused or contributed to;":
        ["text", ""],
      "b.	describe its approach to identify and address grievances, including the grievance mechanisms that the organization has established or participates in;":
        ["text", ""],
      "c.	describe other processes by which the organization provides for or cooperates in the remediation of negative impacts that it identifies it has caused or contributed to;":
        ["text", ""],
      "d.	describe how the stakeholders who are the intended users of the grievance mechanisms are involved in the design, review, operation, and improvement of these mechanisms;":
        ["text", ""],
      "e.	describe how the organization tracks the effectiveness of the grievance mechanisms and other remediation processes, and report examples of their effectiveness, including stakeholder feedback.":
        ["text", ""],
    },
    "2-26 Mechanisms for seeking advice and raising concerns": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	describe the mechanisms for individuals to:": {
        "i. seek advice on implementing the organization's policies and practices for responsible business conduct;":
          ["text", ""],
        "ii. raise concerns about the organization's business conduct.": [
          "text",
          "",
        ],
      },
    },
    "2-27 Compliance with laws and regulations": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	report the total number of significant instances of non-compliance with laws and regulations during the reporting period, and a breakdown of this total by:":
        {
          "i.	instances for which fines were incurred;": ["number", ""],
          "ii.	instances for which non-monetary sanctions were incurred;": [
            "number",
            "",
          ],
        },
      "b.	report the total number and the monetary value of fines for instances of non- compliance with laws and regulations that were paid during the reporting period, and a breakdown of this total by:":
        {
          "i.	fines for instances of non-compliance with laws and regulations that occurred in the current reporting period;":
            ["text", ""],
          "ii.	fines for instances of non-compliance with laws and regulations that occurred in previous reporting periods;":
            ["text", ""],
        },
      "c.	describe the significant instances of non-compliance;": ["text", ""],
      "d.	describe how it has determined significant instances of non-compliance.":
        ["text", ""],
    },
    "2-28 Membership associations": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a. report industry associations, other membership associations, and national or international advocacy organizations in which it participates in a significant role.":
        ["text", ""],
    },
    "2-29 Approach to stakeholder engagement": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a. Describe its approach to engaging with stakeholders": [
        "table",
        [
          {
            Stakeholder: "",
            "Method of identification": "",
            Purpose: "",
            "Engagement method": "",
          },
        ],
      ],
    },
    "2-30 Collective bargaining agreements": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	report the percentage of total employees covered by collective bargaining agreements;":
        ["number", ""],
      "b.	for employees not covered by collective bargaining agreements, report whether the organization determines their working conditions and terms of employment based on collective bargaining agreements that cover its other employees or based on collective bargaining agreements from other organizations.":
        ["text", ""],
    },
  },
  "GRI 3: Material Topics 2021": {
    "3-1 Process to determine material topics": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a. describe the process it has followed to determine its material topics, including:":
        {
          "i. how it has identified actual and potential, negative and positive impacts on the economy, environment, and people, including impacts on their human rights, across its activities and business relationships;":
            ["text", ""],
          "ii. how it has prioritized the impacts for reporting based on their significance;":
            ["text", ""],
        },
      "b. specify the stakeholders and experts whose views have informed the process of determining its material topics.":
        ["text", ""],
    },
    "3-2 List of material topics": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a. list its material topics;": [
        "array",
        [
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 101: Biodiversity 2024",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 201: Economic Performance 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 202: Market Presence 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 203: Indirect Economic Impacts 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 204: Procurement Practices 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 205: Anti-corruption 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 206: Anti-competitive Behavior 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 207: Tax 2019",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 301: Materials 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 302: Energy 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 303: Water and Effluents 2018",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 305: Emissions 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 306: Effluents and Waste 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 306: Waste 2020",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 308: Supplier Environmental Assessment 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 401: Employment 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 402: Labor/Management Relations 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 403: Occupational Health and Safety 2018",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 404: Training and Education 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 405: Diversity and Equal Opportunity 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 406: Non-discrimination 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 407: Freedom of Association and Collective Bargaining 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 408: Child Labor 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 409: Forced or Compulsory Labor 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 410: Security Practices 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 411: Rights of Indigenous Peoples 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 413: Local Communities 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 414: Supplier Social Assessment 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 415: Public Policy 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 416: Customer Health and Safety 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 417: Marketing and Labeling 2016",
          },
          {
            included: false,
            comments: {
              reasonType: "",
              reason: "",
            },
            name: "GRI 418: Customer Privacy 2016",
          },
        ],
      ],
      "b. report changes to the list of material topics compared to the previous reporting period":
        ["text", ""],
    },
    "3-3 Management of material topics": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      topics: {},
    },
  },
  "GRI 101: Biodiversity 2024": {
    "101-1 Policies to halt and reverse biodiversity loss": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	describe its policies or commitments to halt and reverse biodiversity loss, and how these are informed by the 2050 Goals and 2030 Targets in the Kunming-Montreal Global Biodiversity Framework;":
        ["text", ""],
      "b.	report the extent to which these policies or commitments apply to the organization's activities and to its business relationships;":
        ["text", ""],
      "c.	report the goals and targets to halt and reverse biodiversity loss, whether they are informed by scientific consensus, the base year, and the indicators used to evaluate progress.":
        ["text", ""],
    },
    "101-2 Management of biodiversity impacts": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	report how it applies the mitigation hierarchy by describing:": {
        "i.	actions taken to avoid negative impacts on biodiversity;": [
          "text",
          "",
        ],
        "ii.	actions taken to minimize negative impacts on biodiversity that were not avoided;":
          ["text", ""],
        "iii.	actions taken to restore and rehabilitate affected ecosystems, including the goals of the restoration and rehabilitation, and how stakeholders are engaged throughout the restoration and rehabilitation actions;":
          ["text", ""],
        "iv.	actions taken to offset residual negative impacts on biodiversity;":
          ["text", ""],
        "v.	transformative actions taken and additional conservation actions taken;":
          ["text", ""],
      },
      "b.	with reference to 101-2-a-iii, report for each site with the most significant impacts on biodiversity:":
        {
          "i.	the size in hectares of the area under restoration or rehabilitation;":
            ["text", ""],
          "ii.	the size in hectares of the area restored or rehabilitated;": [
            "text",
            "",
          ],
        },
      "c.	with reference to 101-2-a-iv, report for each offset:": {
        "i.	the goals;": ["text", ""],
        "ii.	the geographic location;": ["text", ""],
        "iii.	whether and how principles of good offset practices are met;": [
          "text",
          "",
        ],
        "iv.	whether and how the offset is certified or verified by a third party;":
          ["text", ""],
      },
      "d.	list which of its sites with the most significant impacts on biodiversity have a biodiversity management plan and explain why the other sites do not have a management plan;":
        ["text", ""],
      "e.	describe how it enhances synergies and reduces trade-offs between actions taken to manage its biodiversity and climate change impacts;":
        ["text", ""],
      "f.	describe how it ensures that the actions taken to manage its impacts on biodiversity avoid and minimize negative impacts and maximize positive impacts for stakeholders":
        ["text", ""],
    },
    "101-3 Access and benefit-sharing": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	describe the process to ensure compliance with access and benefit-sharing regulations and measures;":
        ["text", ""],
      "b.	describe voluntary actions taken to advance access and benefit-sharing that are additional to legal obligations or when there are no regulations and measures.":
        ["text", ""],
    },
    "101-4 Identification of biodiversity impacts": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	explain how it has determined which of its sites and which products and services in its supply chain have the most significant actual and potential impacts on biodiversity.":
        ["text", ""],
    },
    "101-5 Locations with biodiversity impacts": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	report the location and size in hectares of its sites with the most significant impacts on biodiversity;":
        ["text", ""],
      "b.	for each site reported under 101-5-a, report whether it is in or near an ecologically sensitive area, the distance to these areas, and whether these are:":
        {
          "i.	areas of biodiversity importance;": ["text", ""],
          "ii.	areas of high ecosystem integrity;": ["text", ""],
          "iii.	areas of rapid decline in ecosystem integrity;": ["text", ""],
          "iv.	areas of high physical water risks;": ["text", ""],
          "v.	areas important for the delivery of ecosystem service benefits to Indigenous Peoples, local communities, and other stakeholders;":
            ["text", ""],
        },

      "c.	report the activities that take place in each site reported under 101-5-a;":
        ["text", ""],
      "d.	report the products and services in its supply chain with the most significant impacts on biodiversity and the countries or jurisdictions where the activities associated with these products and services take place.":
        ["text", ""],
    },
    "101-6 Direct drivers of biodiversity loss": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	for each site reported under 101-5-a where its activities lead or could lead to land and sea use change, report:":
        {
          "i.	the size in hectares of natural ecosystem converted since a cut-off or reference date, the cut-off date or reference date, and the type of ecosystem before and after conversion;":
            ["text", ""],
          "ii.	the size in hectares of land and sea converted from one intensively used or modified ecosystem to another during the reporting period, and the type of ecosystem before and after conversion;":
            ["text", ""],
        },

      "b.	for each site reported under 101-5-a where its activities lead or could lead to the exploitation of natural resources, report:":
        {
          "i.	for each wild species harvested, the quantity, the type, and extinction risk;":
            ["text", ""],
          "ii.	water withdrawal and water consumption in megaliters;": [
            "text",
            "",
          ],
        },
      "c.	for each site reported under 101-5-a where its activities lead or could lead to pollution, report the quantity and the type of each pollutant generated;":
        ["text", ""],
      "d.	for each site reported under 101-5-a where its activities lead or could lead to the introduction of invasive alien species, describe how invasive alien species are or may be introduced;":
        ["text", ""],
      "e.	for each product and service in its supply chain reported under 101-5-d, report the information required under 101-6-a, 101-6-b, 101-6-c, and 101-6-d, with a breakdown by country or jurisdiction;":
        ["text", ""],
      "f.	report contextual information necessary to understand how the data has been compiled, including standards, methodologies, and assumptions used.":
        ["text", ""],
    },
    "101-7 Changes to the state of biodiversity": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	for each site reported under 101-5-a, report the following information on affected or potentially affected ecosystems:":
        {
          "i.	the ecosystem type for the base year;": ["text", ""],
          "ii.	the ecosystem size in hectares for the base year;": [
            "number",
            "",
          ],
          "iii.	the ecosystem condition for the base year and the current reporting period;":
            ["text", ""],
        },

      "b.	report contextual information necessary to understand how the data has been compiled, including standards, methodologies, and assumptions used.":
        ["text", ""],
    },
    "101-8 Ecosystem services": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	for each site reported under 101-5-a, list the ecosystem services and beneficiaries affected or potentially affected by the organization’s activities;":
        ["text", ""],
      "b.	explain how the ecosystem services and beneficiaries are or could be affected by the organization's activities.":
        ["text", ""],
    },
  },
  // "GRI 304: Biodiversity 2016":
  "GRI 201: Economic Performance 2016": {
    "201-1 Direct economic value generated and distributed": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a. Direct economic value generated and distributed (EVG&D) on an accruals basis, including the basic components for the organization’s global operations as listed below. If data are presented on a cash basis, report the justification for this decision in addition to reporting the following basic components:":
        {
          "i. Direct economic value generated: revenues;": ["text", ""],
          "ii. Economic value distributed: operating costs, employee wages and benefits, payments to providers of capital, payments to government by country, and community investments;":
            ["text", ""],
          "iii. Economic value retained: direct economic value generated less economic value distributed. Where significant, report EVG&D separately at country, regional, or market levels, and the criteria used for defining significance.":
            ["text", ""],
        },
      "b. Where significant, report EVG&D separately at country, regional, or market levels, and the criteria used for defining significance.":
        ["text", ""],
    },
    "201-2 Financial implications and other risks and opportunities due to climate change":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.  Risks and opportunities posed by climate change that have the potential to generate substantive changes in operations, revenue, or expenditure, including:":
          {
            "i. a description of the risk or opportunity and its classification as either physical, regulatory, or other;":
              ["text", ""],
            "ii. a description of the impact associated with the risk or opportunity;":
              ["text", ""],
            "iii. the financial implications of the risk or opportunity before action is taken;":
              ["text", ""],
            "iv. the methods used to manage the risk or opportunity;": [
              "text",
              "",
            ],
            "v. the costs of actions taken to manage the risk or opportunity.":
              ["text", ""],
          },
      },
    "201-3 Defined benefit plan obligations and other retirement plans": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.  If the plan's liabilities are met by the organization's general resources, the estimated value of those liabilities.":
        ["number", ""],
      "b. If a separate fund exists to pay the plan’s pension liabilities:": {
        "i. the extent to which the scheme's liabilities are estimated to be covered by the assets that have been set aside to meet them":
          ["number", ""],
        "ii. the basis on which that estimate has been arrived at;": [
          "text",
          "",
        ],
        "iii. when that estimate was made.": ["text", ""],
      },
      "c. If a fund set up to pay the plan's pension liabilities is not fully covered, explain the strategy, if any, adopted by the employer to work towards full coverage, and the timescale, if any, by which the employer hopes to achieve full coverage.":
        ["text", ""],
      "d. Percentage of salary contributed by employee or employer.": [
        "number",
        "",
      ],
      "e. Level of participation in retirement plans, such as participation in mandatory or voluntary schemes, regional, or country-based schemes, or those with financial impact.":
        ["number", ""],
    },
    "201-4 Financial assistance received from government": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total monetary value of financial assistance received by the organization from any government during the reporting period, including:":
        {
          "i. tax relief and tax credits;": ["number", ""],
          "ii. subsidies;": ["number", ""],
          "iii.	investment grants, research and development grants, and other relevant types of grant;":
            ["number", ""],
          "iv. awards;": ["number", ""],
          "v. royalty holidays;": ["number", ""],
          "vi. financial assistance from Export Credit Agencies (ECAs);": [
            "number",
            "",
          ],
          "vii.	financial incentives;": ["number", ""],
          "viii. other financial benefits received or receivable from any government for any operation.":
            ["number", ""],
        },

      "b.	The information in 201-4-a by country.": ["text", ""],
      "c.	Whether, and the extent to which, any government is present in the shareholding structure":
        ["text", ""],
    },
  },
  "GRI 202: Market Presence 2016": {
    "202-1 Ratios of standard entry level wage by gender compared to local minimum wage":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	When a significant proportion of employees are compensated based on wages subject to minimum wage rules, report the relevant ratio of the entry level wage by gender at significant locations of operation to the minimum wage.":
          ["text", ""],
        "b.	When a significant proportion of other workers (excluding employees) performing the organization's activities are compensated based on wages subject to minimum wage rules, describe the actions taken to determine whether these workers are paid above the minimum wage.":
          ["text", ""],
        "c.	Whether a local minimum wage is absent or variable at significant locations of operation, by gender. In circumstances in which different minimums can be used as a reference, report which minimum wage is being used.":
          ["text", ""],
        "d.	The definition used for significant locations of operation": [
          "text",
          "",
        ],
      },
    "202-2 Proportion of senior management hired from the local community": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Percentage of senior management at significant locations of operation that are hired from the local community.":
        ["number", ""],
      "b.	The definition used for senior management.": ["text", ""],
      "c.	The organization's geographical definition of local.": ["text", ""],
      "d.	The definition used for significant locations of operation": [
        "text",
        "",
      ],
    },
  },
  "GRI 203: Indirect Economic Impacts 2016": {
    "203-1 Infrastructure investments and services supported": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Extent of development of significant infrastructure investments and services supported.":
        ["text", ""],
      "b.	Current or expected impacts on communities and local economies, including positive and negative impacts where relevant.":
        ["text", ""],
      "c.Whether these investments and services are commercial, in-kind, or pro bono engagements.":
        ["text", ""],
    },
    "203-2 Significant indirect economic impacts": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Examples of significant identified indirect economic impacts of the organization, including positive and negative impacts.":
        ["text", ""],
      "b. Significance of the indirect economic impacts in the context of external benchmarks and stakeholder priorities, such as national and international standards, protocols, and policy agendas.":
        ["text", ""],
    },
  },
  "GRI 204: Procurement Practices 2016": {
    "204-1 Proportion of spending on local suppliers": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Percentage of the procurement budget used for significant locations of operation that is spent on suppliers local to that operation (such as percentage of products and services purchased locally).":
        ["number", ""],
      "b.	The organization's geographical definition of local.": ["text", ""],
      "c.	The definition used for significant locations of operation.": [
        "text",
        "",
      ],
    },
  },
  "GRI 205: Anti-corruption 2016": {
    "205-1 Operations assessed for risks related to corruption": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total number and percentage of operations assessed for risks related to corruption.":
        ["text", ""],
      "b.	Significant risks related to corruption identified through the risk assessment.":
        ["text", ""],
    },
    "205-2 Communication and training about anti-corruption policies and procedures":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	Total number and percentage of governance body members that the organization's anti- corruption policies and procedures have been communicated to, broken down by region.":
          ["text", ""],
        "b.	Total number and percentage of employees that the organization;s anti-corruption policies and procedures have been communicated to, broken down by employee category and region.":
          ["text", ""],
        "c.	Total number and percentage of business partners that the organization's anti- corruption policies and procedures have been communicated to, broken down by type of business partner and region. Describe if the organization's anti-corruption policies and procedures have been communicated to any other persons or organizations.":
          ["text", ""],
        "d.	Total number and percentage of governance body members that have received training on anti-corruption, broken down by region.":
          ["text", ""],
        "e. Total number and percentage of employees that have received training on anti- corruption, broken down by employee category and region":
          ["text", ""],
      },
    "205-3 Confirmed incidents of corruption and actions taken": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total number and nature of confirmed incidents of corruption.": [
        "text",
        "",
      ],
      "b.	Total number of confirmed incidents in which employees were dismissed or disciplined for corruption.":
        ["number", ""],
      "c.	Total number of confirmed incidents when contracts with business partners were terminated or not renewed due to violations related to corruption.":
        ["number", ""],
      "d.	Public legal cases regarding corruption brought against the organization or its employees during the reporting period and the outcomes of such cases.":
        ["text", ""],
    },
  },
  "GRI 206: Anti-competitive Behavior 2016": {
    "206-1 Legal actions for anti-competitive behavior, anti-trust, and monopoly practices":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a. Number of legal actions pending or completed during the reporting period regarding anti-competitive behavior and violations of anti-trust and monopoly legislation in which the organization has been identified as a participant.":
          ["number", ""],
        "b. Main outcomes of completed legal actions, including any decisions or judgements.":
          ["text", ""],
      },
  },

  "GRI 207: Tax 2019": {
    "207-1 Approach to tax": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "i.	whether the organization has a tax strategy and, if so, a link to this strategy if publicly available;":
        ["text", ""],
      "ii.	the governance body or executive-level position within the organization that formally reviews and approves the tax strategy, and the frequency of this review;":
        ["text", ""],
      "iii.	the approach to regulatory compliance;": ["text", ""],
      "iv.	how the approach to tax is linked to the business and sustainable development strategies of the organization.":
        ["text", ""],
    },
    "207-2 Tax governance, control, and risk management": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	A description of the tax governance and control framework, including:":
        {
          "i.	the governance body or executive-level position within the organization accountable for compliance with the tax strategy;":
            ["text", ""],
          "ii.	how the approach to tax is embedded within the organization;": [
            "text",
            "",
          ],
          "iii.	the approach to tax risks, including how risks are identified, managed, and monitored;":
            ["text", ""],
          "iv.	how compliance with the tax governance and control framework is evaluated.":
            ["text", ""],
        },

      "b.	A description of the mechanisms to raise concerns about the organization's business conduct and the organization's integrity in relation to tax.":
        ["text", ""],
      "c.	A description of the assurance process for disclosures on tax including, if applicable, a link or reference to the external assurance report(s) or assurance statement(s).":
        ["text", ""],
    },
    "207-3 Stakeholder engagement and management of concerns related to tax": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	A description of the approach to stakeholder engagement and management of stakeholder concerns related to tax, including:":
        {
          "i. the approach to engagement with tax authorities;": ["text", ""],
          "ii. the approach to public policy advocacy on tax;": ["text", ""],
          "iii. the processes for collecting and considering the views and concerns of stakeholders, including external stakeholders.":
            ["text", ""],
        },
    },
    "207-4 Country-by-country reporting": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	All tax jurisdictions where the entities included in the organization's audited consolidated financial statements, or in the financial information filed on public record, are resident for tax purposes.":
        ["text", ""],
      "b.	For each tax jurisdiction reported in Disclosure 207-4-a:": {
        "i. Names of the resident entities;": ["text", ""],
        "ii. Primary activities of the organization;": ["text", ""],
        "iii. Number of employees, and the basis of calculation of this number;":
          ["text", ""],
        "iv. Revenues from third-party sales;": ["text", ""],
        "v. Revenues from intra-group transactions with other tax jurisdictions;":
          ["text", ""],
        "vi. Profit/loss before tax;": ["text", ""],
        "vii. Tangible assets other than cash and cash equivalents;": [
          "text",
          "",
        ],
        "viii. Corporate income tax paid on a cash basis;": ["text", ""],
        "ix. Corporate income tax accrued on profit/loss;": ["text", ""],
        "x. Reasons for the difference between corporate income tax accrued on profit/loss and the tax due if the statutory tax rate is applied to profit/loss before tax.":
          ["text", ""],
      },
      "c. The time period covered by the information reported in Disclosure 207-4.":
        ["text", ""],
    },
  },
  "GRI 301: Materials 2016": {
    "301-1 Materials used by weight or volume": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total weight or volume of materials that are used to produce and package the organization’s primary products and services during the reporting period, by:":
        {
          "i. non-renewable materials used;": ["text", ""],
          "ii. renewable materials used.": ["text", ""],
        },
    },
    "301-2 Recycled input materials used": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Percentage of recycled input materials used to manufacture the organization's primary products and services.":
        ["number", ""],
    },
    "301-3 Reclaimed products and their packaging materials": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a. Percentage of reclaimed products and their packaging materials for each product category.":
        ["number", ""],
      "b. How the data for this disclosure have been collected.": ["text", ""],
    },
  },
  "GRI 302: Energy 2016": {
    "302-1 Energy consumption within the organization": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total fuel consumption within the organization from non-renewable sources, in joules or multiples, and including fuel types used.":
        ["number", ""],
      "b.	Total fuel consumption within the organization from renewable sources, in joules or multiples, and including fuel types used.":
        ["number", ""],
      "c.	In joules, watt-hours or multiples, the total:": {
        "i.	electricity consumption": ["number", "", "joules"],
        "ii. heating consumption": ["number", "", "joules"],
        "iii. cooling consumption": ["number", "", "joules"],
        "iv. steam consumption": ["number", "", "joules"],
      },
      "d.	In joules, watt-hours or multiples, the total:": {
        "i.	electricity sold": ["number", "", "joules"],
        "ii. heating sold": ["number", "", "joules"],
        "iii. cooling sold": ["number", "", "joules"],
        "iv. steam sold": ["number", "", "joules"],
      },
      "e.	Total energy consumption within the organization, in joules or multiples.":
        ["number", ""],
      "f.	Standards, methodologies, assumptions, and/or calculation tools used.":
        ["text", ""],
      "g.	Source of the conversion factors used.": ["text", ""],
    },
    "302-2 Energy consumption outside of the organization": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Energy consumption outside of the organization, in joules or multiples.":
        ["number", ""],
      "b.	Standards, methodologies, assumptions, and/or calculation tools used.":
        ["text", ""],
      "c.	Source of the conversion factors used.": ["text", ""],
    },
    "302-3 Energy intensity": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Energy intensity ratio for the organization.": ["number", ""],
      "b.	Organization-specific metric (the denominator) chosen to calculate the ratio.":
        ["text", ""],
      "c.	Types of energy included in the intensity ratio; whether fuel, electricity, heating, cooling, steam, or all.":
        ["text", ""],
      "d.	Whether the ratio uses energy consumption within the organization, outside of it, or both.":
        ["text", ""],
    },
    "302-4 Reduction of energy consumption": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Amount of reductions in energy consumption achieved as a direct result of conservation and efficiency initiatives, in joules or multiples.":
        ["number", ""],
      "b.	Types of energy included in the reductions; whether fuel, electricity, heating, cooling, steam, or all.":
        ["number", ""],
      "c.	Basis for calculating reductions in energy consumption, such as base year or baseline, including the rationale for choosing it.":
        ["text", ""],
      "d.	Standards, methodologies, assumptions, and/or calculation tools used.":
        ["text", ""],
    },
    "302-5 Reductions in energy requirements of products and services": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Reductions in energy requirements of sold products and services achieved during the reporting period, in joules or multiples.":
        ["number", ""],
      "b.	Basis for calculating reductions in energy consumption, such as base year or baseline, including the rationale for choosing it.":
        ["text", ""],
      "c.	Standards, methodologies, assumptions, and/or calculation tools used.":
        ["text", ""],
    },
  },

  "GRI 303: Water and Effluents 2018": {
    "303-1 Interactions with water as a shared resource": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	A description of how the organization interacts with water, including how and where water is withdrawn, consumed, and discharged, and the water-related impacts the organization has caused or contributed to, or that are directly linked to its operations, products, or services by its business relationships (e.g., impacts caused by runoff).":
        ["text", ""],
      "b.	A description of the approach used to identify water-related impacts, including the scope of assessments, their timeframe, and any tools or methodologies used.":
        ["text", ""],
      "c.	A description of how water-related impacts are addressed, including how the organization works with stakeholders to steward water as a shared resource, and how it engages with suppliers or customers with significant water-related impacts.":
        ["text", ""],
      "d.	An explanation of the process for setting any water-related goals and targets that are part of the organization's approach to managing water and effluents, and how they relate to public policy and the local context of each area with water stress.":
        ["text", ""],
    },
    "303-2 Management of water discharge-related impacts": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	A description of any minimum standards set for the quality of effluent discharge, and how these minimum standards were determined, including:":
        {
          "i.	how standards for facilities operating in locations with no local discharge requirements were determined;":
            ["text", ""],
          "ii.	any internally developed water quality standards or guidelines;":
            ["text", ""],
          "iii.	any sector-specific standards considered;": ["text", ""],
          "iv.	whether the profile of the receiving waterbody was considered.": [
            "text",
            "",
          ],
        },
    },
    "303-3 Water withdrawal": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total water withdrawal from all areas in megaliters, and a breakdown of this total by the following sources, if applicable:":
        {
          "i.	Surface water;": ["number", ""],
          "ii. Groundwater;": ["number", ""],
          "iii.	Seawater;": ["number", ""],
          "iv. Produced water;": ["number", ""],
          "v. Third-party water.": ["number", ""],
        },

      "b.	Total water withdrawal from all areas with water stress in megaliters, and a breakdown of this total by the following sources, if applicable:":
        {
          "i.	Surface water;": ["number", ""],
          "ii.	Groundwater;": ["number", ""],
          "iii.	Seawater;": ["number", ""],
          "iv.	Produced water;": ["number", ""],
          "v.	Third-party water, and a breakdown of this total by the withdrawal sources listed in i-iv.":
            ["number", ""],
        },

      "c.	A breakdown of total water withdrawal from each of the sources listed in Disclosures 303-3-a and 303-3-b in megaliters by the following categories:":
        {
          "i. Freshwater (≤1,000 mg/L Total Dissolved Solids);": ["number", ""],
          "ii. Other water (>1,000 mg/L Total Dissolved Solids).": [
            "number",
            "",
          ],
        },

      "d.	Any contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used.":
        ["text", ""],
    },
    "303-4 Water discharge": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total water discharge to all areas in megaliters, and a breakdown of this total by the following types of destination, if applicable:":
        {
          "i.	Surface water;": ["number", ""],
          "ii. Groundwater;": ["number", ""],
          "iii. Seawater;": ["number", ""],
          "iv. Third-party water, and the volume of this total sent for use to other organizations, if applicable.":
            ["number", ""],
        },

      "b.	A breakdown of total water discharge to all areas in megaliters by the following categories:":
        {
          "i.	Freshwater (≤1,000 mg/L Total Dissolved Solids);": ["number", ""],
          "ii.	Other water (>1,000 mg/L Total Dissolved Solids).": [
            "number",
            "",
          ],
        },

      "c.	Total water discharge to all areas with water stress in megaliters, and a breakdown of this total by the following categories:":
        {
          "i. Freshwater (≤1,000 mg/L Total Dissolved Solids);": ["number", ""],
          "ii. Other water (>1,000 mg/L Total Dissolved Solids).": [
            "number",
            "",
          ],
        },

      "d.	Priority substances of concern for which discharges are treated, including:":
        {
          "i.	how priority substances of concern were defined, and any international standard, authoritative list, or criteria used;":
            ["text", ""],
          "ii.	the approach for setting discharge limits for priority substances of concern;":
            ["text", ""],
          "iii.	number of incidents of non-compliance with discharge limits.": [
            "number",
            "",
          ],
        },
      "e.	Any contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used.":
        ["text", ""],
    },
    "303-5 Water consumption": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total water consumption from all areas in megaliters.": ["number", ""],
      "b.	Total water consumption from all areas with water stress in megaliters.":
        ["number", ""],
      "c.	Change in water storage in megaliters, if water storage has been identified as having a significant water-related impact.":
        ["number", ""],
      "d. Any contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used, including whether the information is calculated, estimated, modeled, or sourced from direct measurements, and the approach taken for this, such as the use of any sector-specific factors.":
        ["text", ""],
    },
  },
  "GRI 305: Emissions 2016": {
    "305-1 Direct (Scope 1) GHG emissions": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Gross direct (Scope 1) GHG emissions in metric tons of CO2 equivalent.":
        ["number", ""],
      "b.	Gases included in the calculation; whether CO2 , CH4 , N2 O, HFCs, PFCs, SF6 , NF3 , or all.":
        ["text", ""],
      "c.	Biogenic CO2 emissions in metric tons of CO2 equivalent.": [
        "number",
        "",
      ],
      "d.	Base year for the calculation, if applicable, including:": {
        "i.	the rationale for choosing it;": ["text", ""],
        "ii. emissions in the base year;": ["number", ""],
        "iii.	the context for any significant changes in emissions that triggered recalculations of base year emissions.":
          ["text", ""],
      },
      "e.	Source of the emission factors and the global warming potential (GWP) rates used, or a reference to the GWP source.":
        ["text", ""],
      "f.	Consolidation approach for emissions; whether equity share, financial control, or operational control.":
        ["text", ""],
      "g.	Standards, methodologies, assumptions, and/or calculation tools used.":
        ["text", ""],
    },
    "305-2 Energy indirect (Scope 2) GHG emissions": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Gross location-based energy indirect (Scope 2) GHG emissions in metric tons of CO2 equivalent.":
        ["number", ""],
      "b.	If applicable, gross market-based energy indirect (Scope 2) GHG emissions in metric tons of CO2 equivalent.":
        ["number", ""],
      "c.	If available, the gases included in the calculation; whether CO2 , CH4 , N2 O, HFCs, PFCs, SF6 , NF3 , or all.":
        ["text", ""],
      "d.	Base year for the calculation, if applicable, including:": {
        "i.	the rationale for choosing it;": ["text", ""],
        "ii.	emissions in the base year;": ["number", ""],
        "iii.	the context for any significant changes in emissions that triggered recalculations of base year emissions.":
          ["text", ""],
      },

      "e.	Source of the emission factors and the global warming potential (GWP) rates used, or a reference to the GWP source.":
        ["text", ""],
      "f.	Consolidation approach for emissions; whether equity share, financial control, or operational control.":
        ["text", ""],
      "g.	Standards, methodologies, assumptions, and/or calculation tools used.":
        ["text", ""],
    },
    "305-3 Other indirect (Scope 3) GHG emissions": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Gross other indirect (Scope 3) GHG emissions in metric tons of CO2 equivalent.":
        ["number", ""],
      "b.	If available, the gases included in the calculation; whether CO2 , CH4 , N2 O, HFCs, PFCs, SF6 , NF3 , or all.":
        ["text", ""],
      "c.	Biogenic CO2 emissions in metric tons of CO2 equivalent.": [
        "number",
        "",
      ],
      "d.	Other indirect (Scope 3) GHG emissions categories and activities included in the calculation.":
        ["text", ""],
      "e.	Base year for the calculation, if applicable, including:": {
        "i. the rationale for choosing it;": ["text", ""],
        "ii. emissions in the base year;": ["number", ""],
        "iii. the context for any significant changes in emissions that triggered recalculations of base year emissions.":
          ["text", ""],
      },

      "f. Source of the emission factors and the global warming potential (GWP) rates used, or a reference to the GWP source.":
        ["text", ""],
      "g. Standards, methodologies, assumptions, and/or calculation tools used.":
        ["text", ""],
    },
    "305-4 GHG emissions intensity": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a. GHG emissions intensity ratio for the organization.": ["text", ""],
      "b. Organization-specific metric (the denominator) chosen to calculate the ratio.":
        ["text", ""],
      "c. Types of GHG emissions included in the intensity ratio; whether direct (Scope 1), energy indirect (Scope 2), and/or other indirect (Scope 3).":
        ["text", ""],
      "d. Gases included in the calculation; whether CO2 , CH4 , N2 O, HFCs, PFCs, SF6 , NF3 , or all.":
        ["text", ""],
    },
    "305-5 Reduction of GHG emissions": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	GHG emissions reduced as a direct result of reduction initiatives, in metric tons of CO2 equivalent.":
        ["number", ""],
      "b.	Gases included in the calculation; whether CO2 , CH4 , N2 O, HFCs, PFCs, SF6 , NF3 , or all.":
        ["text", ""],
      "c.	Base year or baseline, including the rationale for choosing it.": [
        "text",
        "",
      ],
      "d.	Scopes in which reductions took place; whether direct (Scope 1), energy indirect (Scope 2), and/or other indirect (Scope 3).":
        ["text", ""],
      "e.	Standards, methodologies, assumptions, and/or calculation tools used.":
        ["text", ""],
    },
    "305-6 Emissions of ozone-depleting substances (ODS)": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Production, imports, and exports of ODS in metric tons of CFC-11 (trichlorofluoromethane) equivalent.":
        ["number", ""],
      "b.	Substances included in the calculation.": ["text", ""],
      "c.	Source of the emission factors used.": ["text", ""],
      "d.	Standards, methodologies, assumptions, and/or calculation tools used.":
        ["text", ""],
    },
    "305-7 Nitrogen oxides (NOx), sulfur oxides (SOx), and other significant air emissions":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	Significant air emissions, in kilograms or multiples, for each of the following:":
          {
            "i. NOx": ["number", ""],
            "ii. SOx": ["number", ""],
            "iii. Persistent organic pollutants (POP)": ["number", ""],
            "iv. Volatile organic compounds (VOC)": ["number", ""],
            "v.	Hazardous air pollutants (HAP)": ["number", ""],
            "vi. Particulate matter (PM)": ["number", ""],
            "vii. Other standard categories of air emissions identified in relevant regulations":
              ["number", ""],
          },

        "b. Source of the emission factors used.": ["text", ""],
        "c. Standards, methodologies, assumptions, and/or calculation tools used.":
          ["text", ""],
      },
  },
  "GRI 306: Effluents and Waste 2016": {
    "306-3 Significant spills": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total number and total volume of recorded significant spills.": [
        "text",
        "",
      ],
      "b.	The following additional information for each spill that was reported in the organization's financial statements:":
        {
          "i.	Location of spill;": ["text", ""],
          "ii.	Volume of spill;": ["text", ""],
          "iii.	Material of spill, categorized by: oil spills (soil or water surfaces), fuel spills (soil or water surfaces), spills of wastes (soil or water surfaces), spills of chemicals (mostly soil or water surfaces), and other (to be specified by the organization).":
            ["text", ""],
        },

      "c.	Impacts of significant spills.": ["text", ""],
    },
  },
  "GRI 306: Waste 2020": {
    "306-1 Waste generation and significant waste-related impacts": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	For the organization's significant actual and potential waste-related impacts, a description of:":
        {
          "i. the inputs, activities, and outputs that lead or could lead to these impacts;":
            ["text", ""],
          "ii. whether these impacts relate to waste generated in the organization's own activities or to waste generated upstream or downstream in its value chain.":
            ["text", ""],
        },
    },
    "306-2 Management of significant waste-related impacts": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Actions, including circularity measures, taken to prevent waste generation in the organization's own activities and upstream and downstream in its value chain, and to manage significant impacts from waste generated.":
        ["text", ""],
      "b.	If the waste generated by the organization in its own activities is managed by a third party, a description of the processes used to determine whether the third party manages the waste in line with contractual or legislative obligations.":
        ["text", ""],
      "c.	The processes used to collect and monitor waste-related data.": [
        "text",
        "",
      ],
    },
    "306-3 Waste generated": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total weight of waste generated in metric tons, and a breakdown of this total by composition of the waste.":
        ["number", ""],
      "b.	Contextual information necessary to understand the data and how the data has been compiled.":
        ["text", ""],
    },
    "306-4 Waste diverted from disposal": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total weight of waste diverted from disposal in metric tons, and a breakdown of this total by composition of the waste.":
        ["number", ""],
      "b.	Total weight of hazardous waste diverted from disposal in metric tons, and a breakdown of this total by the following recovery operations:":
        {
          "i.	Preparation for reuse;": ["number", ""],
          "ii.	Recycling;": ["number", ""],
          "iii.	Other recovery operations.": ["number", ""],
        },

      "c.	Total weight of non-hazardous waste diverted from disposal in metric tons, and a breakdown of this total by the following recovery operations:":
        {
          "i.	Preparation for reuse;": ["number", ""],
          "ii. Recycling;": ["number", ""],
          "iii.	Other recovery operations.": ["number", ""],
        },

      "d.	For each recovery operation listed in Disclosures 306-4-b and 306-4-c, a breakdown of the total weight in metric tons of hazardous waste and of non-hazardous waste diverted from disposal:":
        {
          "i.	onsite;": ["number", ""],
          "ii. offsite.": ["number", ""],
        },
      "e.	Contextual information necessary to understand the data and how the data has been compiled.":
        ["text", ""],
    },
    "306-5 Waste directed to disposal": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total weight of waste directed to disposal in metric tons, and a breakdown of this total by composition of the waste.":
        ["number", ""],
      "b.	Total weight of hazardous waste directed to disposal in metric tons, and a breakdown of this total by the following disposal operations:":
        {
          "i.	Incineration (with energy recovery);": ["number", ""],
          "ii. Incineration (without energy recovery);": ["number", ""],
          "iii.	Landfilling;": ["number", ""],
          "iv. Other disposal operations.": ["number", ""],
        },

      "c.	Total weight of non-hazardous waste directed to disposal in metric tons, and a breakdown of this total by the following disposal operations:":
        {
          "i. Incineration (with energy recovery);": ["number", ""],
          "ii. Incineration (without energy recovery);": ["number", ""],
          "iii. Landfilling;": ["number", ""],
          "iv. Other disposal operations.": ["number", ""],
        },

      "d.	For each disposal operation listed in Disclosures 306-5-b and 306-5-c, a breakdown of the total weight in metric tons of hazardous waste and of non-hazardous waste directed to disposal:":
        {
          "i.	onsite;": ["number", ""],
          "ii.	offsite.": ["number", ""],
        },

      "e.	Contextual information necessary to understand the data and how the data has been compiled.":
        ["text", ""],
    },
  },
  "GRI 308: Supplier Environmental Assessment 2016": {
    "308-1 New suppliers that were screened using environmental criteria": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Percentage of new suppliers that were screened using environmental criteria.":
        ["number", ""],
    },
    "308-2 Negative environmental impacts in the supply chain and actions taken":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	Number of suppliers assessed for environmental impacts.": [
          "number",
          "",
        ],
        "b.	Number of suppliers identified as having significant actual and potential negative environmental impacts.":
          ["number", ""],
        "c.	Significant actual and potential negative environmental impacts identified in the supply chain.":
          ["text", ""],
        "d.	Percentage of suppliers identified as having significant actual and potential negative environmental impacts with which improvements were agreed upon as a result of assessment.":
          ["number", ""],
        "e.	Percentage of suppliers identified as having significant actual and potential negative environmental impacts with which relationships were terminated as a result of assessment, and why.":
          ["text", ""],
      },
  },
  "GRI 401: Employment 2016": {
    "401-1 New employee hires and employee turnover": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total number and rate of new employee hires during the reporting period, by age group, gender and region.":
        ["text", ""],
      "b.	Total number and rate of employee turnover during the reporting period, by age group, gender and region.":
        ["text", ""],
    },
    "401-2 Benefits provided to full-time employees that are not provided to temporary or part-time employees":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	Benefits which are standard for full-time employees of the organization but are not provided to temporary or part-time employees, by significant locations of operation. These include, as a minimum:":
          {
            "i.	life insurance;": ["text", ""],
            "ii.	health care;": ["text", ""],
            "iii.	disability and invalidity coverage;": ["text", ""],
            "iv.	parental leave;": ["text", ""],
            "v.	retirement provision;": ["text", ""],
            "vi.	stock ownership;": ["text", ""],
            "vii.	others.": ["text", ""],
          },

        "b.	The definition used for significant locations of operation.": [
          "text",
          "",
        ],
      },
    "401-3 Parental leave": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total number of employees that were entitled to parental leave, by gender.":
        ["number", ""],
      "b.	Total number of employees that took parental leave, by gender.": [
        "number",
        "",
      ],
      "c.	Total number of employees that returned to work in the reporting period after parental leave ended, by gender.":
        ["number", ""],
      "d.	Total number of employees that returned to work after parental leave ended that were still employed 12 months after their return to work, by gender.":
        ["number", ""],
      "e. Return to work and retention rates of employees that took parental leave, by gender.":
        ["text", ""],
    },
  },
  "GRI 402: Labor/Management Relations 2016": {
    "402-1 Minimum notice periods regarding operational changes": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Minimum number of weeks notice typically provided to employees and their representatives prior to the implementation of significant operational changes that could substantially affect them.":
        ["number", ""],
      "b.	For organizations with collective bargaining agreements, report whether the notice period and provisions for consultation and negotiation are specified in collective agreements.":
        ["text", ""],
    },
  },
  "GRI 403: Occupational Health and Safety 2018": {
    "403-1 Occupational health and safety management system": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	A statement of whether an occupational health and safety management system has been implemented, including whether:":
        {
          "i.	the system has been implemented because of legal requirements and, if so, a list of the requirements;":
            ["text", ""],
          "ii. the system has been implemented based on recognized risk management and/or management system standards/guidelines and, if so, a list of the standards/guidelines.":
            ["text", ""],
        },

      "b.	A description of the scope of workers, activities, and workplaces covered by the occupational health and safety management system, and an explanation of whether and, if so, why any workers, activities, or workplaces are not covered.":
        ["text", ""],
    },
    "403-2 Hazard identification, risk assessment, and incident investigation":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	A description of the processes used to identify work-related hazards and assess risks on a routine and non-routine basis, and to apply the hierarchy of controls in order to eliminate hazards and minimize risks, including:":
          {
            "i.	how the organization ensures the quality of these processes, including the competency of persons who carry them out;":
              ["text", ""],
            "ii. how the results of these processes are used to evaluate and continually improve the occupational health and safety management system.":
              ["text", ""],
          },
        "b.	A description of the processes for workers to report work-related hazards and hazardous situations, and an explanation of how workers are protected against reprisals.":
          ["text", ""],
        "c.	A description of the policies and processes for workers to remove themselves from work situations that they believe could cause injury or ill health, and an explanation of how workers are protected against reprisals.":
          ["text", ""],
        "d.	A description of the processes used to investigate work-related incidents, including the processes to identify hazards and assess risks relating to the incidents, to determine corrective actions using the hierarchy of controls, and to determine improvements needed in the occupational health and safety management system.":
          ["text", ""],
      },
    "403-3 Occupational health services": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	A description of the occupational health services functions that contribute to the identification and elimination of hazards and minimization of risks, and an explanation of how the organization ensures the quality of these services and facilitates workers access to them.":
        ["text", ""],
    },
    "403-4 Worker participation, consultation, and communication on occupational health and safety":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a. A description of the processes for worker participation and consultation in the development, implementation, and evaluation of the occupational health and safety management system, and for providing access to and communicating relevant information on occupational health and safety to workers.":
          ["text", ""],
        "b. Where formal joint management-worker health and safety committees exist, a description of their responsibilities, meeting frequency, decision-making authority, and whether and, if so, why any workers are not represented by these committees.":
          ["text", ""],
      },
    "403-5 Worker training on occupational health and safety": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	A description of any occupational health and safety training provided to workers, including generic training as well as training on specific work-related hazards, hazardous activities, or hazardous situations.":
        ["text", ""],
    },
    "403-6 Promotion of worker health": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a. An explanation of how the organization facilitates workers access to non-occupational medical and healthcare services, and the scope of access provided.":
        ["text", ""],
      "b. A description of any voluntary health promotion services and programs offered to workers to address major non-work-related health risks, including the specific health risks addressed, and how the organization facilitates workers access to these services and programs.":
        ["text", ""],
    },
    "403-7 Prevention and mitigation of occupational health and safety impacts directly linked by business relationships":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.A description of the organization's approach to preventing or mitigating significant negative occupational health and safety impacts that are directly linked to its operations, products, or services by its business relationships, and the related hazards and risks.":
          ["text", ""],
      },
    "403-8 Workers covered by an occupational health and safety management system":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	If the organization has implemented an occupational health and safety management system based on legal requirements and/or recognized standards/guidelines:":
          {
            "i.	the number and percentage of all employees and workers who are not employees but whose work and/or workplace is controlled by the organization, who are covered by such a system;":
              ["text", ""],
            "ii. the number and percentage of all employees and workers who are not employees but whose work and/or workplace is controlled by the organization, who are covered by such a system that has been internally audited;":
              ["text", ""],
            "iii.	the number and percentage of all employees and workers who are not employees but whose work and/or workplace is controlled by the organization, who are covered by such a system that has been audited or certified by an external party.":
              ["text", ""],
          },

        "b.	Whether and, if so, why any workers have been excluded from this disclosure, including the types of worker excluded.":
          ["text", ""],
        "c.	Any contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used":
          ["text", ""],
      },
    "403-9 Work-related injuries": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	For all employees:": {
        "i.	The number and rate of fatalities as a result of work-related injury;":
          ["text", ""],
        "ii.	The number and rate of high-consequence work-related injuries (excluding fatalities);":
          ["text", ""],
        "iii.	The number and rate of recordable work-related injuries;": [
          "text",
          "",
        ],
        "iv. The main types of work-related injury;": ["text", ""],
        "v.	The number of hours worked.": ["number", ""],
      },

      "b.	For all workers who are not employees but whose work and/or workplace is controlled by the organization:":
        {
          "i.	The number and rate of fatalities as a result of work-related injury;":
            ["text", ""],
          "ii.	The number and rate of high-consequence work-related injuries (excluding fatalities);":
            ["text", ""],
          "iii.	The number and rate of recordable work-related injuries;": [
            "text",
            "",
          ],
          "iv.	The main types of work-related injury;": ["text", ""],
          "v.	The number of hours worked.": ["number", ""],
        },

      "c.	The work-related hazards that pose a risk of high-consequence injury, including:":
        {
          "i.	how these hazards have been determined;": ["text", ""],
          "ii.	which of these hazards have caused or contributed to high-consequence injuries during the reporting period;":
            ["text", ""],
          "iii.	actions taken or underway to eliminate these hazards and minimize risks using the hierarchy of controls.":
            ["text", ""],
        },

      "d.	Any actions taken or underway to eliminate other work-related hazards and minimize risks using the hierarchy of controls.":
        ["text", ""],
      "e.	Whether the rates have been calculated based on 200,000 or 1,000,000 hours worked.":
        ["text", ""],
      "f.	Whether and, if so, why any workers have been excluded from this disclosure, including the types of worker excluded.":
        ["text", ""],
      "g.	Any contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used.":
        ["text", ""],
    },
    "403-10 Work-related ill health": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	For all employees": {
        "i.	The number of fatalities as a result of work-related ill health;": [
          "number",
          "",
        ],
        "ii.	The number of cases of recordable work-related ill health;": [
          "number",
          "",
        ],
        "iii.	The main types of work-related ill health.": ["text", ""],
      },
      "b.	For all workers who are not employees but whose work and/or workplace is controlled by the organization:":
        {
          "i.	The number of fatalities as a result of work-related ill health;":
            ["number", ""],
          "ii.	The number of cases of recordable work-related ill health;": [
            "number",
            "",
          ],
          "iii.	The main types of work-related ill health.": ["text", ""],
        },
      "c.	The work-related hazards that pose a risk of ill health, including:": {
        "i.	how these hazards have been determined;": ["text", ""],
        "ii.	which of these hazards have caused or contributed to cases of ill health during the reporting period;":
          ["text", ""],
        "iii.	actions taken or underway to eliminate these hazards and minimize risks using the hierarchy of controls.":
          ["text", ""],
      },

      "d.	Whether and, if so, why any workers have been excluded from this disclosure, including the types of worker excluded.":
        ["text", ""],
      "e.	Any contextual information necessary to understand how the data have been compiled, such as any standards, methodologies, and assumptions used.":
        ["text", ""],
    },
  },
  "GRI 404: Training and Education 2016": {
    "404-1 Average hours of training per year per employee": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Average hours of training that the organization's employees have undertaken during the reporting period, by:":
        {
          "i.gender;": ["number", ""],
          "ii.employee category.": ["number", ""],
        },
    },

    "404-2 Programs for upgrading employee skills and transition assistance programs":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	Type and scope of programs implemented and assistance provided to upgrade employee skills.":
          ["text", ""],
        "b.	Transition assistance programs provided to facilitate continued employability and the management of career endings resulting from retirement or termination of employment.":
          ["text", ""],
      },

    "404-3 Percentage of employees receiving regular performance and career development reviews":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a. Percentage of total employees by gender and by employee category who received a regular performance and career development review during the reporting period.":
          ["text", ""],
      },
  },
  "GRI 405: Diversity and Equal Opportunity 2016": {
    "405-1 Diversity of governance bodies and employees": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Percentage of individuals within the organization's governance bodies in each of the following diversity categories:":
        {
          "i.	Gender;": ["number", ""],
          "ii.	Age group: under 30 years old, 30-50 years old, over 50 years old;":
            ["number", ""],
          "iii.	Other indicators of diversity where relevant (such as minority or vulnerable groups).":
            ["text", ""],
        },

      "b.	Percentage of employees per employee category in each of the following diversity categories:":
        {
          "i.	Gender;": ["number", ""],
          "ii. Age group: under 30 years old, 30-50 years old, over 50 years old;":
            ["number", ""],
          "iii. Other indicators of diversity where relevant (such as minority or vulnerable groups).":
            ["text", ""],
        },
    },
    "405-2 Ratio of basic salary and remuneration of women to men": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Ratio of the basic salary and remuneration of women to men for each employee category, by significant locations of operation.":
        ["text", ""],
      "b. The definition used for significant locations of operation": [
        "text",
        "",
      ],
    },
  },
  "GRI 406: Non-discrimination 2016": {
    "406-1 Incidents of discrimination and corrective actions taken": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total number of incidents of discrimination during the reporting period.":
        ["number", ""],
      "b.	Status of the incidents and actions taken with reference to the following:":
        {
          "i.	Incident reviewed by the organization;": ["text", ""],
          "ii.	Remediation plans being implemented;": ["text", ""],
          "iii.	Remediation plans that have been implemented, with results reviewed through routine internal management review processes;":
            ["text", ""],
          "iv. Incident no longer subject to action.": ["text", ""],
        },
    },
  },
  "GRI 407: Freedom of Association and Collective Bargaining 2016": {
    "407-1 Operations and suppliers in which the right to freedom of association and collective bargaining may be at risk":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	Operations and suppliers in which workers rights to exercise freedom of association or collective bargaining may be violated or at significant risk either in terms of:":
          {
            "i. type of operation (such as manufacturing plant) and supplier;":
              ["text", ""],
            "ii. countries or geographic areas with operations and suppliers considered at risk.":
              ["text", ""],
          },

        "b.	Measures taken by the organization in the reporting period intended to support rights to exercise freedom of association and collective bargaining.":
          ["text", ""],
      },
  },
  "GRI 408: Child Labor 2016": {
    "408-1 Operations and suppliers at significant risk for incidents of child labor":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	Operations and suppliers considered to have significant risk for incidents of:":
          {
            "i.	child labor;": ["text", ""],
            "ii. young workers exposed to hazardous work.": ["text", ""],
          },

        "b.	Operations and suppliers considered to have significant risk for incidents of child labor either in terms of:":
          {
            "i.	type of operation (such as manufacturing plant) and supplier;": [
              "text",
              "",
            ],
            "ii.	countries or geographic areas with operations and suppliers considered at risk.":
              ["text", ""],
          },

        "c.	Measures taken by the organization in the reporting period intended to contribute to the effective abolition of child labor.":
          ["text", ""],
      },
  },
  "GRI 409: Forced or Compulsory Labor 2016": {
    "409-1 Operations and suppliers at significant risk for incidents of forced or compulsory labor":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	Operations and suppliers considered to have significant risk for incidents of forced or compulsory labor either in terms of:":
          {
            "i.	type of operation (such as manufacturing plant) and supplier;": [
              "text",
              "",
            ],
            "ii. countries or geographic areas with operations and suppliers considered at risk.":
              ["text", ""],
          },
        "b.	Measures taken by the organization in the reporting period intended to contribute to the elimination of all forms of forced or compulsory labor.":
          ["text", ""],
      },
  },
  "GRI 410: Security Practices 2016": {
    "410-1 Security personnel trained in human rights policies or procedures": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a. Percentage of security personnel who have received formal training in the organization's human rights policies or specific procedures and their application to security.":
        ["number", ""],
      "b. Whether training requirements also apply to third-party organizations providing security personnel.":
        ["text", ""],
    },
  },
  "GRI 411: Rights of Indigenous Peoples 2016": {
    "411-1 Incidents of violations involving rights of indigenous peoples": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total number of identified incidents of violations involving the rights of indigenous peoples during the reporting period.":
        ["number", ""],
      "b.	Status of the incidents and actions taken with reference to the following:":
        {
          "i. Incident reviewed by the organization;": ["text", ""],
          "ii. Remediation plans being implemented;": ["text", ""],
          "iii. Remediation plans that have been implemented, with results reviewed through routine internal management review processes;":
            ["text", ""],
          "iv. Incident no longer subject to action.": ["text", ""],
        },
    },
  },
  "GRI 413: Local Communities 2016": {
    "413-1 Operations with local community engagement, impact assessments, and development programs":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	Percentage of operations with implemented local community engagement, impact assessments, and/or development programs, including the use of:":
          {
            "i.	social impact assessments, including gender impact assessments, based on participatory processes;":
              ["text", ""],
            "ii. environmental impact assessments and ongoing monitoring;": [
              "text",
              "",
            ],
            "iii. public disclosure of results of environmental and social impact assessments;":
              ["text", ""],
            "iv. local community development programs based on local communities’ needs;":
              ["text", ""],
            "v.	stakeholder engagement plans based on stakeholder mapping;": [
              "text",
              "",
            ],
            "vi. broad based local community consultation committees and processes that include vulnerable groups;":
              ["text", ""],
            "vii.	works councils, occupational health and safety committees and other worker representation bodies to deal with impacts;":
              ["text", ""],
            "viii. formal local community grievance processes.": ["text", ""],
          },
      },
    "413-2 Operations with significant actual and potential negative impacts on local communities":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	Operations with significant actual and potential negative impacts on local communities, including:":
          {
            "i. the location of the operations;": ["text", ""],
            "ii. the significant actual and potential negative impacts of operations.":
              ["text", ""],
          },
      },
  },

  "GRI 414: Supplier Social Assessment 2016": {
    "414-1 New suppliers that were screened using social criteria": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Percentage of new suppliers that were screened using social criteria.":
        ["number", ""],
    },
    "414-2 Negative social impacts in the supply chain and actions taken": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Number of suppliers assessed for social impacts.": ["number", ""],
      "b.	Number of suppliers identified as having significant actual and potential negative social impacts.":
        ["number", ""],
      "c.	Significant actual and potential negative social impacts identified in the supply chain.":
        ["text", ""],
      "d.	Percentage of suppliers identified as having significant actual and potential negative social impacts with which improvements were agreed upon as a result of assessment.":
        ["number", ""],
      "e. Percentage of suppliers identified as having significant actual and potential negative social impacts with which relationships were terminated as a result of assessment, and why.":
        ["text", ""],
    },
  },
  "GRI 415: Public Policy 2016": {
    "415-1 Political contributions": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total monetary value of financial and in-kind political contributions made directly and indirectly by the organization by country and recipient/beneficiary.":
        ["number", ""],
      "b.	If applicable, how the monetary value of in-kind contributions was estimated.":
        ["text", ""],
    },
  },
  "GRI 416: Customer Health and Safety 2016": {
    "416-1 Assessment of the health and safety impacts of product and service categories":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a. Percentage of significant product and service categories for which health and safety impacts are assessed for improvement.":
          ["number", ""],
      },
    "416-2 Incidents of non-compliance concerning the health and safety impacts of products and services":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	Total number of incidents of non-compliance with regulations and/or voluntary codes concerning the health and safety impacts of products and services within the reporting period, by:":
          {
            "i. incidents of non-compliance with regulations resulting in a fine or penalty;":
              ["number", ""],
            "ii. incidents of non-compliance with regulations resulting in a warning;":
              ["number", ""],
            "iii. incidents of non-compliance with voluntary codes.": [
              "text",
              "",
            ],
          },
        "b.	If the organization has not identified any non-compliance with regulations and/or voluntary codes, a brief statement of this fact is sufficient.":
          ["text", ""],
      },
  },
  "GRI 417: Marketing and Labeling 2016": {
    "417-1 Requirements for product and service information and labeling": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Whether each of the following types of information is required by the organization’s procedures for product and service information and labeling:":
        {
          "i.	The sourcing of components of the product or service;": [
            "text",
            "",
          ],
          "ii. Content, particularly with regard to substances that might produce an environmental or social impact;":
            ["text", ""],
          "iii.	Safe use of the product or service;": ["text", ""],
          "iv. Disposal of the product and environmental or social impacts;": [
            "text",
            "",
          ],
          "v.	Other (explain).": ["text", ""],
        },
      "b.	Percentage of significant product or service categories covered by and assessed for compliance with such procedures.":
        ["number", ""],
    },
    "417-2 Incidents of non-compliance concerning product and service information and labeling":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	Total number of incidents of non-compliance with regulations and/or voluntary codes concerning product and service information and labeling, by:":
          {
            "i.	incidents of non-compliance with regulations resulting in a fine or penalty;":
              ["number", ""],
            "ii.	incidents of non-compliance with regulations resulting in a warning;":
              ["number", ""],
            "iii.	incidents of non-compliance with voluntary codes.": [
              "number",
              "",
            ],
          },
        "b.	If the organization has not identified any non-compliance with regulations and/or voluntary codes, a brief statement of this fact is sufficient.":
          ["text", ""],
      },
    "417-3 Incidents of non-compliance concerning marketing communications": {
      comments: {
        reasonType: "",
        reason: "",
      },
      attachments: [],
      "a.	Total number of incidents of non-compliance with regulations and/or voluntary codes concerning marketing communications, including advertising, promotion, and sponsorship, by:":
        {
          "i.	incidents of non-compliance with regulations resulting in a fine or penalty;":
            ["number", ""],
          "ii. incidents of non-compliance with regulations resulting in a warning;":
            ["number", ""],
          "iii. incidents of non-compliance with voluntary codes.": [
            "number",
            "",
          ],
        },

      "b.	If the organization has not identified any non-compliance with regulations and/or voluntary codes, a brief statement of this fact is sufficient.":
        ["text", ""],
    },
  },
  "GRI 418: Customer Privacy 2016": {
    "418-1 Substantiated complaints concerning breaches of customer privacy and losses of customer data":
      {
        comments: {
          reasonType: "",
          reason: "",
        },
        attachments: [],
        "a.	Total number of substantiated complaints received concerning breaches of customer privacy, categorized by:":
          {
            "i.	complaints received from outside parties and substantiated by the organization;":
              ["number", ""],
            "ii. complaints from regulatory bodies.": ["number", ""],
          },

        "b.	Total number of identified leaks, thefts, or losses of customer data.":
          ["number", ""],
        "c.	If the organization has not identified any substantiated complaints, a brief statement of this fact is sufficient.":
          ["text", ""],
      },
  },
};

export const topics33 = {
  "a. describe the actual and potential, negative and positive impacts on the economy, environment, and people, including impacts on their human rights;":
    ["text", ""],
  "b. report whether the organization is involved with the negative impacts through its activities or as a result of its business relationships, and describe the activities or business relationships;":
    ["text", ""],
  "c. describe its policies or commitments regarding the material topic;": [
    "text",
    "",
  ],
  "d. describe actions taken to manage the topic and related impacts, including:":
    {
      "i.  actions to prevent or mitigate potential negative impacts;": [
        "text",
        "",
      ],
      "ii. actions to address actual negative impacts, including actions to provide for or cooperate in their remediation;":
        ["text", ""],
      "iii. actions to manage actual and potential positive impacts;": [
        "text",
        "",
      ],
    },

  "e. report the following information about tracking the effectiveness of the actions taken:":
    {
      "i. processes used to track the effectiveness of the actions;": [
        "text",
        "",
      ],
      "ii. goals, targets, and indicators used to evaluate progress;": [
        "text",
        "",
      ],
      "iii. the effectiveness of the actions, including progress toward the goals and targets;":
        ["text", ""],
      "iii. lessons learned and how these have been incorporated into the organization's operational policies and procedures;":
        ["text", ""],
    },
  "f. describe how engagement with stakeholders has informed the actions taken (3-3-d) and how it has informed whether the actions have been effective (3-3-e)":
    ["text", ""],
};
